// removed by extract-text-webpack-plugin
module.exports = {"locationContainer":"NCNvAkUNU2SXQeuCW_NCg","locationTitle":"_2p57N4ncYQhwmqXnYfSB37","map":"fWkwlj1ISrQAR96WYs_Sr"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/patientplaylist/InfoDoctor/DoctorLocation/DoctorLocation.scss
// module id = 1644
// module chunks = 0